/**
 * Estado comercial da conta — fonte: user.trial (retornado por /auth/me)
 *
 * @typedef {'active' | 'expiring_soon' | 'expired' | 'none'} TrialStatus
 *
 * @typedef {Object} TrialInfo
 * @property {TrialStatus} status
 * @property {boolean}     active      - true enquanto trial está vigente (não expirado)
 * @property {number}      daysLeft    - dias restantes (0 quando hoje é o último dia)
 * @property {string|null} expiresAt   - ISO 8601 ou null quando não há trial
 */

/**
 * Status global da empresa — fonte: user.company.status (retornado por /auth/me)
 *
 * @typedef {'active' | 'trial' | 'inactive' | 'cancelled'} CompanyStatus
 */

/**
 * Motivo de bloqueio retornado pelo backend (campo `code` no body do 403).
 *
 * @typedef {'TRIAL_EXPIRED' | 'SUBSCRIPTION_CANCELLED' | 'COMPANY_INACTIVE'} AccountBlockReason
 */

/**
 * Mensagens de exibição para cada motivo de bloqueio.
 *
 * @type {Record<AccountBlockReason, string>}
 */
export const BLOCK_REASON_MESSAGES = {
  TRIAL_EXPIRED: 'Seu período de teste encerrou. Escolha um plano para continuar usando o sistema.',
  SUBSCRIPTION_CANCELLED:
    'Sua assinatura foi cancelada. Reative seu plano para recuperar o acesso.',
  COMPANY_INACTIVE: 'Sua empresa está inativa. Entre em contato com o suporte para regularizar.',
};

/**
 * Títulos para cada motivo de bloqueio.
 *
 * @type {Record<AccountBlockReason, string>}
 */
export const BLOCK_REASON_TITLES = {
  TRIAL_EXPIRED: 'Período de teste encerrado',
  SUBSCRIPTION_CANCELLED: 'Assinatura cancelada',
  COMPANY_INACTIVE: 'Empresa inativa',
};

/**
 * Threshold em dias para considerar trial "expirando em breve".
 */
export const TRIAL_EXPIRING_SOON_DAYS = 3;
